import "./styles.css"
export const Footer: React.FC = () => {
  return (
    <footer id="footer" className="row justify-content-between align-items-center border-top">
      <div className="col-md-12 d-flex align-items-center">
        <span className="mb-md-0 text-muted" style={{fontSize: "12px"}}>Todos os direitos reservados ao Cachaça Gestor Ltda © {new Date().getFullYear()}</span>
      </div>
    
    </footer>
  )
}